export default "__VITE_ASSET__b54af50b__"